// Функция для изменения стилей
function fixFoxerCallbackPosition() {
    document.querySelectorAll('div.foxerCallback.closed, .customClb').forEach(el => {
        el.style.setProperty('top', '40%', 'important');
    });
}

// Запуск при загрузке страницы
document.addEventListener('DOMContentLoaded', fixFoxerCallbackPosition);

// Если элементы могут появляться динамически (например, после AJAX)
const observer = new MutationObserver(() => {
    fixFoxerCallbackPosition();
});
observer.observe(document.body, { childList: true, subtree: true });

function disableRightClickOnImages() {
  document.querySelectorAll('img').forEach(function(img) {
    img.addEventListener('contextmenu', function(e) {
      e.preventDefault();
    });
  });
}

// Запускаем после полной загрузки DOM
document.addEventListener('DOMContentLoaded', disableRightClickOnImages);